import { SignedIn, SignedOut, SignInButton, SignUpButton, UserButton } from '@clerk/clerk-react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import QuickStart from './pages/QuickStart';
import New from './pages/New';
import Jobs from './pages/Jobs';
import Job from './pages/Job';
import Billing from './pages/Billing';
import Status from './pages/Status';

import { GlobalProvider } from './providers/GlobalProvider.jsx';
import { useGlobal } from './state';
import { Button } from './components/input';
import { FFSignInButton } from './components/signin';
import { Code } from './components/code';
import { calendarUrl, discordUrl, docsUrl, headerHeight } from './constants';
import './App.css';

const mustLogin = (el, props = {}) => <OnlySignedIn {...props}>{el}</OnlySignedIn>;

function App() {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <Inner />
      </BrowserRouter>
    </GlobalProvider>
  );
}

const OnlySignedIn = ({ children, signInText, ...props }) => {
  const node = (
    <div>
      <div style={{ width: 400, margin: '40px auto', border: '1px solid #ccc', borderRadius: 20, padding: 40 }}>
        <div style={{ fontWeight: 'bold', fontSize: '120%', marginBottom: 10 }}>Sign In</div>
        <p>Click the button below to sign in and use FetchFox</p>
        <FFSignInButton {...props}>{signInText || 'Sign In'}</FFSignInButton>
      </div>
    </div>
  );

  return (
    <div>
      <SignedIn>{children}</SignedIn>
      <SignedOut>{node}</SignedOut>
    </div>
  );
};

const Inner = () => {
  const { apiKey, host } = useGlobal();
  const location = useLocation();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <header
        style={{
          borderBottom: '1px solid #ccc',
          display: 'flex',
          alignItems: 'center',
          position: 'fixed',
          gap: 10,
          top: 0,
          left: 0,
          zIndex: 100,
          width: '100vw',
          background: 'white',
          padding: '10px 15px',
          height: headerHeight,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <Link to="/">
            <img src="/logo.svg" style={{ height: 30 }} />
          </Link>

          {/*
          <div>
            <Button trans black to="/">
              Home
            </Button>
          </div>
          <div>
            <Button trans black to="/jobs">
              Jobs
            </Button>
          </div>
          */}
        </div>

        <div style={{ flexGrow: 1 }}></div>

        <div style={{ fontSize: 12, fontFamily: 'monospace' }}>
          {apiKey && (
            <span>
              API Key:
              <Code language="text" code={apiKey} inline copy />
            </span>
          )}
        </div>

        <div>
          <Button grayFlat small black href={calendarUrl}>
            Book a Call
          </Button>
        </div>

        <div>
          <Button grayFlat small black href={discordUrl}>
            Discord
          </Button>
        </div>

        <div>
          <Button grayFlat small black href={docsUrl}>
            Docs
          </Button>
        </div>

        <SignedOut>
          <div style={{ display: 'flex', gap: 10 }}>
            <SignInButton>
              <Button black grayFlat small>
                Sign In
              </Button>
            </SignInButton>
            <SignUpButton>
              <Button small>Sign Up</Button>
            </SignUpButton>
          </div>
        </SignedOut>

        <SignedIn>
          {location.pathname == '/' && (
            <Button small to="/dashboard">
              Dashboard &raquo;
            </Button>
          )}
          <UserButton />
        </SignedIn>
      </header>

      <main style={{ marginTop: 60 }}>
        <Routes>
          <Route path="/" element={<Landing />} />

          <Route path="/new" element={mustLogin(<New />)} />
          <Route
            path="/dashboard"
            element={mustLogin(<Dashboard />, {
              signUpFallbackRedirectUrl: '/quick-start',
              signInFallbackRedirectUrl: '/dashboard',
            })}
          />
          <Route path="/quick-start" element={mustLogin(<QuickStart />)} />
          <Route path="/jobs" element={mustLogin(<Jobs />)} />
          <Route path="/billing" element={mustLogin(<Billing />)} />
          <Route path="/jobs/:id" element={mustLogin(<Job />)} />
          <Route path="/status" element={mustLogin(<Status />)} />
        </Routes>
      </main>
      <ToastContainer theme="light" position="bottom-center" />
    </div>
  );
};

export default App;
